var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pr-4 py-2"},[_c('div',{staticClass:"caption text--secondary"},[_vm._v("カード名義")]),_c('div',{staticClass:"whitespace-no-wrap"},[_vm._v(_vm._s(_vm.payment.holderName))])])}
var staticRenderFns = []

export { render, staticRenderFns }